import { Injectable } from '@angular/core';
import {
  HttpHeaderHelper,
  HttpHeader,
  ContentType,
  DataList,
  DataSingle,
  Response,
  HttpRequest
} from 'src/app/model';
import {
  HttpClient, HttpHeaders, HttpParams
} from '@angular/common/http';
import { HeaderService } from 'src/app/service';
import { Observable, pipe } from 'rxjs';
import {environment} from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ContactService {
  headers: Array<HttpHeaderHelper> = [
    new HttpHeaderHelper(HttpHeader.CONTENT_TYPE, ContentType.APPLICATION_JSON),
    new HttpHeaderHelper(HttpHeader.ACCEPT, ContentType.APPLICATION_JSON),
    new HttpHeaderHelper(HttpHeader.AUTHORIZATION, `Bearer token`)
  ];

  constructor(
    private http: HttpClient,
    private headerSvc: HeaderService
  ) {}

  postContactItem(body: any): Observable<Response<DataSingle<any>>> {
    console.log('Posting contact item');
    return this.http.post<Response<DataSingle<any>>>(`${environment.apiUrl}api/v1/contact`, body, {headers:this.headerSvc.buildHeaders(this.headers)});
  }
}
